import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { getDefaultRouteForRole } from '../../shared/utils/rbac';
import ProtectedRoute from '../../shared/components/ProtectedRoute';
import DashboardLayout from '../../layouts/DashboardLayout';

const BootstrapSpinner = () => (
  <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
    <CircularProgress />
  </Box>
);

export const LoginRoute = ({ children }) => {
  const status = useSelector((state) => state.auth.status);
  const role = useSelector((state) => state.auth.role);

  if (status === 'bootstrapping') {
    return <BootstrapSpinner />;
  }

  if (status === 'authenticated') {
    return <Navigate to={getDefaultRouteForRole(role)} replace />;
  }

  return children;
};

export const HomeRedirect = () => {
  const status = useSelector((state) => state.auth.status);
  const role = useSelector((state) => state.auth.role);

  if (status === 'bootstrapping') {
    return <BootstrapSpinner />;
  }

  if (status === 'authenticated') {
    return <Navigate to={getDefaultRouteForRole(role)} replace />;
  }

  return <Navigate to="/login" replace />;
};

export const SecuredPage = ({
  permission,
  allowedRoles,
  requireSociety,
  requireSocietyForRoles,
  featureFlag,
  title,
  children,
}) => (
  <ProtectedRoute
    permission={permission}
    allowedRoles={allowedRoles}
    requireSociety={requireSociety}
    requireSocietyForRoles={requireSocietyForRoles}
    featureFlag={featureFlag}
  >
    <DashboardLayout title={title}>{children}</DashboardLayout>
  </ProtectedRoute>
);
